(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["landing-page-rr"] && !Shopify.designMode) return;
  try {
    
  class MerigoldLp {
    constructor(root) {
      this.root = root;
      this.form = root.querySelector('[data-mglp-form]');
      if (!this.form) return;

      this.sizes = Array.from(root.querySelectorAll('[data-mglp-size]'));
      this.buttons = Array.from(root.querySelectorAll('[data-mglp-atc]'));
      this.labels = Array.from(root.querySelectorAll('[data-mglp-atc-label]'));
      this.stickyBar = root.querySelector('[data-mglp-sticky]');
      this.stickySize = root.querySelector('[data-mglp-sticky-size]');
      this.stickyPrice = root.querySelector('[data-mglp-sticky-price]');
      this.status = root.querySelector('[data-mglp-status]');

      for (const label of this.labels) {
        label.dataset.template = label.textContent.trim();
      }

      this.onSizeChange = this.onSizeChange.bind(this);
      this.onSubmit = this.onSubmit.bind(this);

      for (const input of this.sizes) {
        input.addEventListener('change', this.onSizeChange);
      }
      this.form.addEventListener('submit', this.onSubmit);

      if (this.stickyBar) {
        this.stickyBar.hidden = false;
        this.observeSticky();
      }

      this.syncSelection();
    }

    get selected() {
      return this.sizes.find((input) => input.checked) || this.sizes[0];
    }

    onSizeChange() {
      this.syncSelection();
    }

    syncSelection() {
      const input = this.selected;
      if (!input) return;

      const price = input.dataset.price || '';
      const name = input.dataset.name || '';

      for (const label of this.labels) {
        const template = label.dataset.template || label.textContent;
        label.textContent = template.includes('—')
          ? `${template.split('—')[0].trim()} — ${price}`
          : template;
      }

      if (this.stickySize) this.stickySize.textContent = name;
      if (this.stickyPrice) this.stickyPrice.textContent = price;
    }

    observeSticky() {
      if (!('IntersectionObserver' in window)) return;

      this.observer = new IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            this.stickyBar.dataset.visible = entry.isIntersecting ? 'false' : 'true';
          }
        },
        { rootMargin: '0px 0px -100% 0px' }
      );
      this.observer.observe(this.form);
    }

    onSubmit(event) {
      const input = this.selected;
      if (!input) return;

      // Broadcast owns the POST, the drawer refresh and the open animation.
      // Without JS this never fires and the form posts natively to /cart/add.
      event.preventDefault();

      const button = event.submitter || this.buttons[0];
      const label = button ? button.querySelector('[data-mglp-atc-label]') : null;

      for (const btn of this.buttons) btn.setAttribute('aria-busy', 'true');

      document.dispatchEvent(
        new CustomEvent('theme:cart:add', {
          bubbles: true,
          detail: {
            element: this.root,
            label: label ? label.textContent : '',
            button: button,
            data: { id: Number(input.value), quantity: 1 },
          },
        })
      );

      if (this.status) this.status.textContent = 'Added to your bag.';

      window.setTimeout(() => {
        for (const btn of this.buttons) btn.removeAttribute('aria-busy');
      }, 1200);
    }

    destroy() {
      this.observer?.disconnect();
    }
  }

  class MerigoldScents {
    constructor(root) {
      this.root = root;
      this.form = root.querySelector('[data-mglp-scent-form]');
      if (!this.form) return;

      this.grid = root.querySelector('[data-mglp-scent-grid]');
      this.scents = Array.from(root.querySelectorAll('[data-mglp-scent]'));
      this.variantInput = root.querySelector('[data-mglp-scent-variant]');
      this.sizeWrap = root.querySelector('[data-mglp-scent-sizes]');
      this.sizeRow = root.querySelector('[data-mglp-scent-size-row]');
      this.labels = Array.from(root.querySelectorAll('[data-mglp-atc-label]'));
      this.heroImg = root.querySelector('.mglp__hero-media .mglp__media-img');
      this.stickySize = root.querySelector('[data-mglp-sticky-size]');
      this.stickyPrice = root.querySelector('[data-mglp-sticky-price]');

      for (const label of this.labels) label.dataset.template = label.textContent.trim();

      this.onScentChange = this.onScentChange.bind(this);
      this.onSizeChange = this.onSizeChange.bind(this);

      for (const s of this.scents) s.addEventListener('change', this.onScentChange);
      this.sizeRow?.addEventListener('change', this.onSizeChange);

      if (root.dataset.shuffle === 'true') this.#shuffle();
      this.#applyScent(this.scents.find((s) => s.checked) || this.scents[0]);
    }

    #shuffle() {
      if (!this.grid) return;
      const items = Array.from(this.grid.children);
      // Fisher-Yates. Keeps "Surprise me" pinned last if present.
      const random = items.filter((el) => el.querySelector('[data-random]'));
      const rest = items.filter((el) => !el.querySelector('[data-random]'));
      for (let i = rest.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [rest[i], rest[j]] = [rest[j], rest[i]];
      }
      for (const el of [...rest, ...random]) this.grid.appendChild(el);
    }

    get #pickable() {
      return this.scents.filter((s) => !s.disabled && !s.dataset.random);
    }

    #resolve(input) {
      // "Surprise me" resolves to a real scent at selection time.
      if (input?.dataset.random === 'true') {
        const pool = this.#pickable;
        return pool[Math.floor(Math.random() * pool.length)] || null;
      }
      return input;
    }

    #variantsOf(input) {
      try {
        return JSON.parse(input.dataset.variants || '[]');
      } catch {
        return [];
      }
    }

    onScentChange(event) {
      this.#applyScent(event.target);
    }

    onSizeChange(event) {
      if (!event.target.matches('[data-mglp-scent-size]')) return;
      this.#setVariant(event.target.value, event.target.dataset.price, event.target.dataset.title);
    }

    #applyScent(input) {
      if (!input) return;

      const resolved = this.#resolve(input);
      if (!resolved) return;

      const variants = this.#variantsOf(resolved).filter((v) => v.available);
      if (!variants.length) return;

      // Swap the hero image to the chosen scent.
      if (this.heroImg && resolved.dataset.hero) {
        this.heroImg.src = resolved.dataset.hero;
        this.heroImg.removeAttribute('srcset');
        this.heroImg.alt = resolved.dataset.label || '';
      }

      // Only show a size row when this scent actually has more than one.
      if (variants.length > 1) {
        this.sizeRow.innerHTML = variants
          .map(
            (v, i) => `
            <label class="mglp__scent-size">
              <input type="radio" name="mglp-scent-size" value="${v.id}"
                data-mglp-scent-size data-price="${v.price}" data-title="${v.title}"
                ${i === 0 ? 'checked' : ''}>
              <span class="mglp__scent-size-name">${v.title}</span>
              <span class="mglp__scent-size-price">${v.price}</span>
            </label>`
          )
          .join('');
        this.sizeWrap.hidden = false;
      } else {
        this.sizeRow.innerHTML = '';
        this.sizeWrap.hidden = true;
      }

      const chosen = variants[0];
      this.#setVariant(chosen.id, chosen.price, resolved.dataset.label);
    }

    #setVariant(id, price, title) {
      if (this.variantInput) this.variantInput.value = id;

      for (const label of this.labels) {
        const template = label.dataset.template || label.textContent;
        label.textContent = template.includes('—')
          ? `${template.split('—')[0].trim()} — ${price}`
          : template;
      }

      if (this.stickySize) this.stickySize.textContent = title || '';
      if (this.stickyPrice) this.stickyPrice.textContent = price || '';
    }
  }

  class MerigoldWaitlist {
    constructor(root) {
      this.root = root;
      this.form = root.querySelector('[data-mglp-waitlist-form]');
      if (!this.form) return;

      this.status = root.querySelector('[data-mglp-waitlist-status]');
      this.input = this.form.querySelector('input[type="email"]');
      this.button = this.form.querySelector('button');
      this.companyId = root.dataset.company;
      this.listId = root.dataset.list;

      this.onSubmit = this.onSubmit.bind(this);
      this.form.addEventListener('submit', this.onSubmit);
    }

    #say(message, isError) {
      if (!this.status) return;
      this.status.textContent = message;
      this.status.dataset.state = isError ? 'error' : 'success';
    }

    async onSubmit(event) {
      event.preventDefault();

      const email = this.input?.value.trim();
      if (!email || !this.input.checkValidity()) {
        this.#say('Enter a valid email address.', true);
        return;
      }

      if (!this.companyId || !this.listId) {
        this.#say(this.status?.dataset.error || 'Not configured yet.', true);
        return;
      }

      this.button.setAttribute('aria-busy', 'true');

      try {
        // Klaviyo client-side subscribe. The company ID is a PUBLIC key —
        // it is safe in theme source. Never put a private key here.
        const response = await fetch(
          `https://a.klaviyo.com/client/subscriptions/?company_id=${encodeURIComponent(this.companyId)}`,
          {
            method: 'POST',
            headers: { 'content-type': 'application/json', revision: '2024-10-15' },
            body: JSON.stringify({
              data: {
                type: 'subscription',
                attributes: {
                  profile: { data: { type: 'profile', attributes: { email } } },
                },
                relationships: { list: { data: { type: 'list', id: this.listId } } },
              },
            }),
          }
        );

        if (!response.ok) throw new Error(`HTTP ${response.status}`);

        this.#say(this.status?.dataset.success || "You're on the list.", false);
        this.form.reset();
        this.form.hidden = true;
      } catch (error) {
        this.#say(this.status?.dataset.error || 'That didn’t go through.', true);
      } finally {
        this.button.removeAttribute('aria-busy');
      }
    }
  }

  // Sticky "join the waitlist" — scroll to the top form and put the cursor in
  // it. A bare hash jump lands you at the field but still requires a tap.
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest?.('[data-mglp-waitlist-jump]');
    if (!trigger) return;

    const target = document.querySelector(trigger.getAttribute('href'));
    if (!target) return;

    event.preventDefault();

    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    target.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'center' });

    const field = target.querySelector('input[type="email"]');
    if (!field) return;

    if (reduced) {
      field.focus({ preventScroll: true });
      return;
    }

    // Wait for the smooth scroll to settle before focusing, or the browser
    // yanks the page again to bring the focused field into view.
    let last = null;
    let still = 0;
    const settle = () => {
      const y = Math.round(window.scrollY);
      still = y === last ? still + 1 : 0;
      last = y;
      if (still > 2) {
        field.focus({ preventScroll: true });
        return;
      }
      requestAnimationFrame(settle);
    };
    requestAnimationFrame(settle);
  });

  const mgLpInstances = new WeakMap();
  const mgScentInstances = new WeakMap();

  const initMgLp = (scope) => {
    const roots = (scope || document).querySelectorAll('[data-mglp-root]');
    for (const root of roots) {
      if (mgLpInstances.has(root)) continue;
      mgLpInstances.set(root, new MerigoldLp(root));
    }

    for (const wl of (scope || document).querySelectorAll('[data-mglp-waitlist]')) {
      if (mgLpInstances.has(wl)) continue;
      mgLpInstances.set(wl, new MerigoldWaitlist(wl));
    }

    for (const sc of (scope || document).querySelectorAll('[data-mglp-scent-form]')) {
      const host = sc.closest('[data-mglp-root]');
      if (!host || mgScentInstances.has(sc)) continue;
      mgScentInstances.set(sc, new MerigoldScents(host));
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initMgLp());
  } else {
    initMgLp();
  }

  document.addEventListener('shopify:section:load', (event) => initMgLp(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    const root = event.target.querySelector('[data-mglp-root]');
    if (!root) return;
    mgLpInstances.get(root)?.destroy();
    mgLpInstances.delete(root);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-focus"] && !Shopify.designMode) return;
  try {
    
  class MerigoldPdp {
    constructor(root) {
      this.root = root;
      this.form = root.querySelector('[data-mgpdp-form]');
      if (!this.form) return;

      this.sizes = Array.from(root.querySelectorAll('[data-mgpdp-size]'));
      this.priceTargets = Array.from(root.querySelectorAll('[data-mgpdp-atc-label]'));
      this.stickyBar = root.querySelector('[data-mgpdp-sticky]');
      this.stickySize = root.querySelector('[data-mgpdp-sticky-size]');
      this.stickyPrice = root.querySelector('[data-mgpdp-sticky-price]');
      this.status = root.querySelector('[data-mgpdp-status]');
      this.buttons = Array.from(root.querySelectorAll('[data-mgpdp-atc]'));

      // Cache each button's label template so the price can be swapped in place.
      for (const button of this.buttons) {
        const label = button.querySelector('[data-mgpdp-atc-label]');
        if (label) label.dataset.template = label.textContent.trim();
      }

      this.onSizeChange = this.onSizeChange.bind(this);
      this.onSubmit = this.onSubmit.bind(this);
      this.onScroll = this.onScroll.bind(this);

      for (const input of this.sizes) {
        input.addEventListener('change', this.onSizeChange);
      }
      this.form.addEventListener('submit', this.onSubmit);

      if (this.stickyBar) {
        this.stickyBar.hidden = false;
        this.observeSticky();
      }

      this.syncSelection();
    }

    get selected() {
      return this.sizes.find((input) => input.checked) || this.sizes[0];
    }

    onSizeChange() {
      this.syncSelection();
    }

    syncSelection() {
      const input = this.selected;
      if (!input) return;

      const price = input.dataset.price || '';
      const name = input.dataset.name || '';

      for (const label of this.priceTargets) {
        const template = label.dataset.template || label.textContent;
        // Only labels authored with a price suffix get the live price swapped in.
        label.textContent = template.includes('—') ? `${template.split('—')[0].trim()} — ${price}` : template;
      }

      if (this.stickySize) this.stickySize.textContent = name;
      if (this.stickyPrice) this.stickyPrice.textContent = price;
    }

    observeSticky() {
      const anchor = this.root.querySelector('[data-mgpdp-form]');
      if (!anchor || !('IntersectionObserver' in window)) return;

      this.observer = new IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            this.stickyBar.dataset.visible = entry.isIntersecting ? 'false' : 'true';
          }
        },
        { rootMargin: '0px 0px -100% 0px' }
      );
      this.observer.observe(anchor);
    }

    onScroll() {}

    async onSubmit(event) {
      const input = this.selected;
      if (!input) return;

      // Broadcast handles the POST, the drawer refresh and the open animation.
      // Without JS this handler never runs and the form posts natively.
      event.preventDefault();

      const button = event.submitter || this.buttons[0];
      const label = button ? button.querySelector('[data-mgpdp-atc-label]') : null;

      for (const btn of this.buttons) btn.setAttribute('aria-busy', 'true');

      document.dispatchEvent(
        new CustomEvent('theme:cart:add', {
          bubbles: true,
          detail: {
            element: this.root,
            label: label ? label.textContent : '',
            button: button,
            data: { id: Number(input.value), quantity: 1 },
          },
        })
      );

      if (this.status) this.status.textContent = 'Added to your cart.';

      window.setTimeout(() => {
        for (const btn of this.buttons) btn.removeAttribute('aria-busy');
      }, 1200);
    }

    destroy() {
      this.observer?.disconnect();
    }
  }

  const mgPdpInstances = new WeakMap();

  const initMgPdp = (scope) => {
    const roots = (scope || document).querySelectorAll('[data-mgpdp-root]');
    for (const root of roots) {
      if (mgPdpInstances.has(root)) continue;
      mgPdpInstances.set(root, new MerigoldPdp(root));
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initMgPdp());
  } else {
    initMgPdp();
  }

  // Theme editor support
  document.addEventListener('shopify:section:load', (event) => initMgPdp(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    const root = event.target.querySelector('[data-mgpdp-root]');
    if (!root) return;
    mgPdpInstances.get(root)?.destroy();
    mgPdpInstances.delete(root);
  });

  } catch(e) { console.error(e); }
})();
})();
